export default __webpack_public_path__ + "static/media/yacht_in_the_sea.42051311.jpg";